import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from '../../../components/Header';
import PropTypes from 'prop-types';

const AdminHeader = ({ onLogout }) => (
  <Header>
    <NavLink exact to="/admin" activeClassName="active">
      PRODUCTION
    </NavLink>
    <a href="#" onClick={e => { e.preventDefault(); onLogout(); }}>
      LOGOUT
    </a>
  </Header>
);

AdminHeader.propTypes = {
  onLogout: PropTypes.func.isRequired
};

export default AdminHeader;
